// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__296py","description":"PatientConsentPreview_description__18gfq"};